import MpNumberTextField from "src/components/MpTextFieldNumberOnly";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";

function UpperThresholdTextField({
  value,
  onChange,
  isInvalid,
  fieldName,
}: {
  value: string;
  onChange: (value: string) => void;
  isInvalid: boolean;
  fieldName?: string;
}) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { tc } = useTranslation(translatePrefix);

  return (
    <div>
      <MpNumberTextField
        sx={{ width: "100%" }}
        label={tc("phInputField", {
          fieldName: fieldName || tc("threshold_upper"),
        })}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {isInvalid && (
        <div
          style={{ position: "absolute", fontSize: "10px", color: "#F85858" }}
        >
          {tc("threshold_upper_helper_text")}
        </div>
      )}
    </div>
  );
}

export default UpperThresholdTextField;
